import { IApiStore } from '@core/api/apiStore';
import { EndpointCallParams } from '@core/api/endpointCallParams';


type ToggleLicenseParams = {
    UnityId: string;
    IsDisabled: boolean;
}

export const performToggleLicense = async (api: IApiStore, params: EndpointCallParams<ToggleLicenseParams>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('identity-app/api/v1/License/Toggle', {
            ...rest,
            payload,
        })

    return req;
}
